import React from 'react';
import '../template-file-css/document-file-template.css'; 


export const AFHS_OrderOfServices = ({
    itemsRef,
    showErrorFor, 
}) => {

    return (
        <form id='AFHS_OrderOfServices' className='file-pdf-document'>
            <div className='file-template'>  
            <p className='w-750'><h3>ORDER OF SERVICES</h3></p>

<table>
    <tr>
        <td className='w-375'>
            <span className='eleHeader'>Client Name:</span></td>
        <td className='w-375'>
            <span className='eleHeader'>Insurance:</span></td>
    </tr>
    <tr>
        <td className='w-375'>
            <input type='text' id='txtClientName' name='txtClientName' className='add-only' /></td>
        <td className='w-375'>
            <input type='text' id='txtInsurance' name='txtInsurance' className='add-only' /></td>
    </tr>
    <tr>
        <td className='w-250'>
            <span className='eleHeader'>Start Date:</span></td>
        <td className='w-250'>
            <span className='eleHeader'>End Date:</span></td>
        <td className='w-250'>
            <span className='eleHeader'>Policy #:</span></td>
    </tr>
    <tr>
        <td className='w-250'>
            <input type='date' id='txtStartDate' name='txtStartDate' className='add-only' /></td>
        <td className='w-250'>
            <input type='date' id='txtEndDate' name='txtEndDate' className='add-only' /></td>
        <td className='w-250'>
            <input type='text' id='txtPolicy' name='txtPolicy' className='add-only' /></td>
    </tr>

</table>

<p className='w-750'>Based upon the Comprehensive (Biopsychosocial) Assessment and/or other relevant information, I order for
    the Individual to receive the following checked services:</p>

<p className='w-750'><h3>ONLY CHECK SERVICES THAT ARE BEING PROVIDED</h3></p>

<table>
    <tr>
        <td className='w-750'>
            <span className='eleHeader'>Non-Medical Orders:</span>
            <span>(Licensed Clinician Only)</span>
        </td>
    </tr>
    <tr>
        <td className='w-375'>
            <input type='checkbox' id='cbNonMedicalOrder_1' name='cbNonMedicalOrder_1' className='add-only' value='BehavioralHealth' />Behavioral Health Assessment/Service Plan Development</td>
        <td className='w-375'>
            <input type='checkbox' id='cbNonMedicalOrder_2' name='cbNonMedicalOrder_2' className='add-only' value='CrisisIntervention' /> Crisis Intervention</td>
    </tr>
    <tr>
        <td className='w-375'>
            <input type='checkbox' id='cbNonMedicalOrder_3' name='cbNonMedicalOrder_3' className='add-only' value='CommunitySupport' /> Community Support (C&A)</td>
        <td className='w-375'>
            <input type='checkbox' id='cbNonMedicalOrder_4' name='cbNonMedicalOrder_4' className='add-only' value='CaseManagement' /> Case Management (Adults)</td>
    </tr>
    <tr>
        <td className='w-375'>
            <input type='checkbox' id='cbNonMedicalOrder_5' name='cbNonMedicalOrder_5' className='add-only' value='PsychosocialRehabilitation' /> Psychosocial Rehabilitation-Individual (Adults)</td>
        <td className='w-375'>
            <input type='checkbox' id='cbNonMedicalOrder_6' name='cbNonMedicalOrder_6' className='add-only' value='PsychosocialRehabilitationGroup' /> Psychosocial Rehabilitation-Group (Adults)</td>
    </tr>
    <tr>
        <td className='w-375'>
            <input type='checkbox' id='cbNonMedicalOrder_7' name='cbNonMedicalOrder_7' className='add-only' value='IndividualCounseling' /> Individual Counseling</td>
        <td className='w-375'>
            <input type='checkbox' id='cbNonMedicalOrder_8' name='cbNonMedicalOrder_8' className='add-only' value='FamilyTraining/Counseling' /> Family Training/Counseling</td>
    </tr>
    <tr>
        <td className='w-375'>
            <input type='checkbox' id='cbNonMedicalOrder_9' name='cbNonMedicalOrder_9' className='add-only' value='GroupTrainingCounseling' /> Group Training/Counseling</td>
        <td className='w-375'>
            <input type='checkbox' id='cbNonMedicalOrder_10' name='cbNonMedicalOrder_10' className='add-only' value='AddictiveDiseases' /> Addictive Diseases Support Services (ADSS)</td>
    </tr>
    <tr>
        <td className='w-375'>
            <input type='checkbox' id='cbNonMedicalOrder_11' name='cbNonMedicalOrder_11' className='add-only' value='PeerSupportServicesIndividual' /> Peer Support Services-Individual</td>
        <td className='w-375'>
            <input type='checkbox' id='cbNonMedicalOrder_12' name='cbNonMedicalOrder_12' className='add-only' value='PeerSupportServicesGroup' /> Peer Support Services-Group</td>
    </tr>
    <tr>
        <td className='w-375'>
            <input type='checkbox' id='cbNonMedicalOrder_13' name='cbNonMedicalOrder_13' className='add-only' value='PeerSupportWholeHealthWellness' /> Peer Support Whole Health & Wellness</td>
        <td className='w-375'>
            <input type='checkbox' id='cbNonMedicalOrder_14' name='cbNonMedicalOrder_14' className='add-only' value='PsychologicalTesting' /> Psychological Testing</td>
    </tr>
    <tr>
        <td className='w-375'>
            <input type='checkbox' id='cbNonMedicalOrder_15' name='cbNonMedicalOrder_15' className='add-only' value='CommunityTransitioningPlanning' /> Community Transitioning Planning</td>
        <td className='w-375'>
            <input type='checkbox' id='cbNonMedicalOrder_16' name='cbNonMedicalOrder_16' className='add-only' value='DiagnosticAssessment' /> Diagnostic Assessment</td>
    </tr>
    <tr>
        <td className='w-375'>
            <input type='checkbox' id='cbNonMedicalOrder_17' name='cbNonMedicalOrder_17' className='add-only' value='SubstanceAbuseIntensiveOutpatientProgram' /> Substance Abuse Intensive Outpatient Program</td>
        <td className='w-375'>&nbsp;</td>
    </tr>


</table>

<table>
    <tr>
        <td className='w-750'>
            <span className='eleHeader'>Medical Order:</span>
            <span>(Physician/APRN Only)</span>
        </td>
    </tr>
    <tr>
        <td className='w-375'>
            <input type='checkbox' id='cbMedicalOrder_18' name='cbMedicalOrder_18' className='add-only' value='DiagnosticAssessmentOnly' /> Diagnostic Assessment (MD Only)</td>
        <td className='w-375'>
            <input type='checkbox' id='cbMedicalOrder_19' name='cbMedicalOrder_19' className='add-only' value='PsychiatricTreatmentOnly' /> Psychiatric Treatment (MD Only)</td>
    </tr>
    <tr>
        <td className='w-375'>
            <input type='checkbox' id='cbMedicalOrder_20' name='cbMedicalOrder_20' className='add-only' value='NursingAssessmentHealthServicesOnly' /> Nursing Assessment/Health Services (MD Only)</td>
        <td className='w-375'>
            <input type='checkbox' id='cbMedicalOrder_21' name='cbMedicalOrder_21' className='add-only' value='MedicationAdministrationOnly' /> Medication Administration (MD Only)</td>
    </tr>
    <tr>
        <td className='w-375'>
            <input type='checkbox' id='cbMedicalOrder_22' name='cbMedicalOrder_22' className='add-only' value='PsychologicalTesting' /> Psychological Testing</td>
        <td className='w-375'>&nbsp;</td>
    </tr>

</table>

<p className='w-750'><h3>The above Non-Medical Orders have been ordered by: (LICENCSED CLINICIANS ONLY)</h3></p>

<table>
    <tr>
        <td className='signature w-300'>&nbsp; </td>
        <td className='signature w-300'>&nbsp; </td>
        <td className='signature w-150'>&nbsp; </td>
    </tr>
    <tr>
        <td className='small w-300'>Printed Name/Credentials</td>
        <td className='small w-300'>Signature and Credentials </td>
        <td className='small w-150'>Date</td>
    </tr>
</table>

<p className='w-750'><h3>The above Medical Orders have been order by: (MD ONLY)</h3></p>

<table>
    <tr>
        <td className='signature w-300'>&nbsp; </td>
        <td className='signature w-300'>&nbsp; </td>
        <td className='signature w-150'>&nbsp; </td>
    </tr>
    <tr>
        <td className='small w-300'>Printed Name/Credentials</td>
        <td className='small w-300'>Signature and Credentials</td>
        <td className='small w-150'>Date</td>
    </tr>
</table>



 



            </div>
        </form>

    )
}   